import { render, staticRenderFns } from "./ContactLayoutUsersAssigned.vue?vue&type=template&id=5c5d58ce&scoped=true"
import script from "./ContactLayoutUsersAssigned.vue?vue&type=script&lang=js"
export * from "./ContactLayoutUsersAssigned.vue?vue&type=script&lang=js"
import style0 from "./ContactLayoutUsersAssigned.vue?vue&type=style&index=0&id=5c5d58ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d58ce",
  null
  
)

export default component.exports